import { useEffect, useState } from "react";
import Table from "../../../../../../../common/components/table"
import { useAppDispatch } from "../../../../../../../hooks/hooks";
import { useSelector } from "react-redux";
import Popup from "../../../../../../../common/components/popup";
import EmailMarketingPlanComponent from "./email-marketing-plan.component";
import PageLoader from "../../../../../../../components/PageLoader";
import { deepCopy } from "../../../../../../../common/services/common.service";
import { useDebounce } from "../../../../../../../common/components/form/hooks/use-debounce.hook";
import _ from "lodash";
import { selectMarketingEmailPlansListItems, selectMarketingEmailPlansQueryItems } from "../../../../../../../redux/marketing-email-plans/selector";
import { marketingEmailplans } from "../../../../../../../redux/marketing-email-plans/action";

export const EmailMarketingPlansComponent = ({
  choosenPlan,
  campaignFrequency,
  choosenEmailPlan,
  setChoosenEmailPlan,
  emailBudget,
  emailNotes,
  // handleInnerEmailFormChange,
  customerTags,
id
}: any) => {


    const dispatch = useAppDispatch();
    const lsitMarketingPlansData = useSelector(selectMarketingEmailPlansListItems);
    const queryEmailMarketingPlansData = useSelector(selectMarketingEmailPlansQueryItems)
    const [pageData, setPageData] = useState(1)
    const [pageSize, setPageSize] = useState(10);
    const[openNewEmailMarketingPlanForm, setOpenNewEmailMarketingPlanForm] = useState<boolean>(false);
    const[openEditEmailMarketingPlanForm, setOpenEditEmailMarketingPlanForm] = useState<boolean>(false);
    const[editPlan, setEditPlan] = useState<boolean>(false);
    const[selectedEmailPlan, setSelectedEmailPlan] = useState<any>({
      "Name": choosenPlan.Name,
      "MarketingPlanId": choosenPlan.Id,
      "FrequencyId": choosenPlan.CampaignFrequencyId,
      "RecipientTagIdInclusions": [],
      "ReplyToEmailInclusions": [],
      "CCTagIdInclusions": [],
      "BCCTagIdInclusions": [],
      "StartDate": choosenPlan.StartDate,
      "EndDate": choosenPlan.EndDate
    });

  
    const [columnDefs, setColumnDefs] = useState({});
    const createColumnDefs: any = () => {
        setColumnDefs([
        {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
                return parseInt(
                params.node.id,
                10
                ) + 1;
            },
        },
        { field: 'Name', headerName: 'Name' , isEdit: true},
        { field: 'FrequencyId', headerName: 'Frequency',},
        // { field: 'DisplayOrder', headerName: 'Display Order' },
        { field: 'StartDate', headerName: 'Start Date', isDateValueFormat:true},
        { field: 'EndDate', headerName: 'End Date', isDateValueFormat:true } 
      
        ]);
      }

      const handleInnerEmailFormChange: any = (event: any, field: string) => {
        console.log('choosenEmailPlan123', selectedEmailPlan)
        setSelectedEmailPlan({ ...selectedEmailPlan, [field]: event })
      }
    

      const additionButtons: any = [
        {
          name: 'Add New Email Plan',
          callback: () => handleCreateNewEmailPlan(),
        }
      ];
    

      //#region local functions
      const handleEdit = (data: any) => {
        // setOpenNewEmailMarketingPlanForm(true)
        setEditPlan(true)
        queryEmailMarketingPlan(data?.Id)
      }

      const handleDelete = (data: any) => {
          dispatch(marketingEmailplans.delete({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/plan/email-plans/delete`,
            entity: 'email',
            jsonData: {
              Records: [
                {     
                  Id: data?.Id
                }
      
              ]
            }
          }));
        }

      const closeModal = () =>{
        setOpenNewEmailMarketingPlanForm(false)
        setOpenEditEmailMarketingPlanForm(false)
      }

      const handleSubmit = () => {
        console.log('saving selectedEmailPlan', selectedEmailPlan)
        if(selectedEmailPlan.Id === 0){
          createEmailMarketingPlan();
        } else {
          updateEmailMarketingPlan();
        }
          lsitEmailMarketingPlans();
          closeModal();
      }

      const handleCreateNewEmailPlan = () => {
        setSelectedEmailPlan({
          "Id": 0,
          "Name": choosenPlan.Name,
          "MarketingPlanId": choosenPlan.Id,
          "FrequencyId": choosenPlan.CampaignFrequencyId,
          "RecipientTagIdInclusions": [],
          "ReplyToEmailInclusions": [],
          "CCTagIdInclusions": [],
          "BCCTagIdInclusions": [],
          "StartDate": choosenPlan.StartDate,
          "EndDate": choosenPlan.EndDate
        })
        setOpenNewEmailMarketingPlanForm(true)        
      }
      
      const ShowNewEmailMarketingPlanForm = () => {
        return (
          <>
          <Popup onClose={closeModal}>
              <EmailMarketingPlanComponent 
                campaignFrequency ={campaignFrequency}
                customerTags ={customerTags}
                choosenPlan={choosenPlan}
                choosenEmailPlan ={selectedEmailPlan}
                emailBudget={emailBudget}
                emailNotes={emailNotes}
                handleInnerFormChange={handleInnerEmailFormChange}
                closeModal={closeModal}
                handleSubmit={handleSubmit}
              />  
            </Popup>
          </>
        )
      }

      const ShowEditEmailMarketingPlanForm = () => {
        return (
          <>
          <Popup onClose={closeModal}>
              <EmailMarketingPlanComponent 
                campaignFrequency ={campaignFrequency}
                customerTags ={customerTags}
                choosenPlan={choosenPlan}
                choosenEmailPlan ={selectedEmailPlan}
                emailBudget={emailBudget}
                emailNotes={emailNotes}
                handleInnerFormChange={handleInnerEmailFormChange}
                closeModal={closeModal}
                handleSubmit={handleSubmit}
              />  
            </Popup>
          </>
        )
      }


      //#endregion

      //#region API Calls
      const lsitEmailMarketingPlans = () => {
        dispatch(marketingEmailplans.list({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/plan/email-plans/list`,
          entity: 'plans',
          jsonData: {   
                 "Filters": [
					{
					  "FieldName": "MarketingPlanId",
					  "FilterOperatorId": 1,
					  "FieldValue": id,
					  "FieldType": "number"
					}
				  ],
          }
        }))
      }
    
      const queryEmailMarketingPlan = (id: Number) => {
        dispatch(marketingEmailplans.query({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/plan/email-plans/query`,
          entity: 'plans',
          jsonData: {
            "Records": [
              {
                "Id": id
              }
            ]
          }
        }))
      }
    
      const createEmailMarketingPlan = async () => {
        const emailPlan = deepCopy(selectedEmailPlan)
        emailPlan["ReplyToEmailInclusions"] = _.isArray(selectedEmailPlan?.ReplyToEmailInclusions)? selectedEmailPlan?.ReplyToEmailInclusions : [selectedEmailPlan?.ReplyToEmailInclusions] //array of strings
        await dispatch(marketingEmailplans.resetAction({ actionType: 'create' }))
        await dispatch(marketingEmailplans.create({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/plan/email-plans`,
          entity: 'plans',
          jsonData: {
            "Records": [
              emailPlan
            ]
          }
        }))
        lsitEmailMarketingPlans()
      }
    
      const updateEmailMarketingPlan = async () => {
        // https://api.digiit.io/api/v4.0/marketing/plan/email-plans
        const emailPlan = deepCopy(selectedEmailPlan)
        emailPlan["ReplyToEmailInclusions"] = _.isArray(selectedEmailPlan?.ReplyToEmailInclusions)? selectedEmailPlan?.ReplyToEmailInclusions : [selectedEmailPlan?.ReplyToEmailInclusions] //array of strings
        await dispatch(marketingEmailplans.resetAction({ actionType: 'update' }))
        await dispatch(marketingEmailplans.update({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/plan/email-plans`,
          entity: 'plans',
          jsonData: {
            "Records": [
              emailPlan
            ]
          }
        }))
      }
      //#endregion

      //#region     
      useEffect(() => {
        console.log('queryEmailMarketingPlansData', queryEmailMarketingPlansData)
        console.log('editPlan', editPlan)
        if(editPlan && queryEmailMarketingPlansData?.result?.items){
          setSelectedEmailPlan(queryEmailMarketingPlansData?.result?.items)
          setOpenEditEmailMarketingPlanForm(true)
        } else {
          setSelectedEmailPlan({
            "Id": 0,
            "Name": choosenPlan.Name,
            "MarketingPlanId": choosenPlan.Id,
            "FrequencyId": choosenPlan.CampaignFrequencyId,
            "RecipientTagIdInclusions": [],
            "ReplyToEmailInclusions": [],
            "CCTagIdInclusions": [],
            "BCCTagIdInclusions": [],
            "StartDate": choosenPlan.StartDate,
            "EndDate": choosenPlan.EndDate
          })
        }
      }, [queryEmailMarketingPlansData]);

      useEffect(() => {
        createColumnDefs();
        lsitEmailMarketingPlans();
      }, []);
      //#endregion

    return (
        <>
        {lsitMarketingPlansData?.isLoading && <PageLoader />}
        {lsitMarketingPlansData && <Table 
            columnData={columnDefs} 
            rowData={lsitMarketingPlansData?.result?.items} 
            setPageData={setPageData} 
            setPageSize={setPageSize}
            paginationData={lsitMarketingPlansData?.result?.pagination} 
            onEdit={handleEdit} 
            onDelete={handleDelete} 
            additionButtons={additionButtons} 
            headingName="Marketing Email Plan" />}

            {openNewEmailMarketingPlanForm && <ShowNewEmailMarketingPlanForm />}
            {openEditEmailMarketingPlanForm && <ShowEditEmailMarketingPlanForm />}
        </>
    )
}